export default __webpack_public_path__ + "assets/audio/1-50399750_clip.mp3";